"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMRenderer = void 0;
var tslib_1 = require("tslib");
var declarative_shadow_dom_polyfill_1 = require("declarative-shadow-dom-polyfill");
var web_streams_polyfill_1 = require("web-streams-polyfill");
var web_utility_1 = require("web-utility");
var VDOM_1 = require("./VDOM");
var DOMRenderer = /** @class */ (function () {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.keyOf = function (_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || '') + index;
        };
        this.vNodeOf = function (list, key) {
            return list.find(function (vNode, index) { return "".concat(_this.keyOf(vNode, index)) === String(key); });
        };
        this.propsKeyOf = function (key) {
            return key.startsWith('aria-')
                ? (0, web_utility_1.toCamelCase)(key)
                : _this.eventPattern.test(key)
                    ? key.toLowerCase()
                    : key;
        };
        this.removeProperty = function (node, key) {
            return _this.eventPattern.test(key)
                ? (node[key.toLowerCase()] = null)
                : node.removeAttribute(_this.ariaPattern.test(key) ? (0, web_utility_1.toHyphenCase)(key) : VDOM_1.VNode.propsMap[key] || key);
        };
        this.setProperty = function (node, key, value) {
            var isXML = (0, web_utility_1.templateOf)(node.tagName) && (0, web_utility_1.elementTypeOf)(node.tagName) === 'xml';
            if (isXML || key.includes('-'))
                node.setAttribute(key, value);
            else
                try {
                    var name_1 = _this.propsKeyOf(key);
                    if (_this.eventPattern.test(key) && !(name_1 in node))
                        _this.handleCustomEvent(node, name_1.slice(2));
                    node[name_1] = value;
                }
                catch (_a) {
                    node.setAttribute(key, value);
                }
        };
    }
    DOMRenderer.prototype.updateProps = function (node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) { oldProps = {}; }
        if (newProps === void 0) { newProps = {}; }
        var group = (0, web_utility_1.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for (var _c = tslib_1.__values(group[web_utility_1.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = tslib_1.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 ? void 0 : onDelete(node, key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _f = tslib_1.__values(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read((group[web_utility_1.DiffStatus.Same] || [])), false), tslib_1.__read((group[web_utility_1.DiffStatus.New] || [])), false)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var _h = tslib_1.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key])
                    if (onAdd instanceof Function)
                        onAdd(node, key, newProps[key]);
                    else
                        Reflect.set(node, key, newProps[key]);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    DOMRenderer.prototype.createNode = function (vNode, reusedVNodes) {
        var _a;
        if (vNode.text)
            return vNode.createDOM(this.document);
        var reusedVNode = vNode.selector && ((_a = reusedVNodes === null || reusedVNodes === void 0 ? void 0 : reusedVNodes[vNode.selector]) === null || _a === void 0 ? void 0 : _a.shift());
        vNode.node = (reusedVNode === null || reusedVNode === void 0 ? void 0 : reusedVNode.node) || vNode.createDOM(this.document);
        var node = this.patch(reusedVNode || new VDOM_1.VNode({ tagName: vNode.tagName, node: vNode.node }), vNode).node;
        return node;
    };
    DOMRenderer.prototype.deleteNode = function (_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment)
            children === null || children === void 0 ? void 0 : children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 ? void 0 : ref();
        }
    };
    DOMRenderer.prototype.commitChildren = function (root, newNodes) {
        var e_3, _a;
        try {
            for (var _b = tslib_1.__values(tslib_1.__spreadArray([], tslib_1.__read(root.childNodes), false)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var oldNode = _c.value;
                var index = newNodes.indexOf(oldNode);
                if (index < 0)
                    continue;
                else if (index === 0) {
                    newNodes.shift();
                    continue;
                }
                var beforeNodes = newNodes.slice(0, index);
                if (!beforeNodes[0])
                    continue;
                oldNode.before.apply(oldNode, tslib_1.__spreadArray([], tslib_1.__read(beforeNodes), false));
                newNodes = newNodes.slice(index + 1);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (newNodes[0])
            root.append.apply(root, tslib_1.__spreadArray([], tslib_1.__read(newNodes), false));
    };
    DOMRenderer.prototype.updateChildren = function (node, oldList, newList) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var _c = (0, web_utility_1.diffKeys)(oldList.map(this.keyOf), newList.map(this.keyOf)), map = _c.map, group = _c.group;
        var deletingGroup = group[web_utility_1.DiffStatus.Old] &&
            (0, web_utility_1.groupBy)(group[web_utility_1.DiffStatus.Old].map(function (_a) {
                var _b = tslib_1.__read(_a, 1), key = _b[0];
                return _this.vNodeOf(oldList, key);
            }), function (_a) {
                var selector = _a.selector;
                return selector + '';
            });
        var newNodes = newList.map(function (vNode, index) {
            var key = _this.keyOf(vNode, index);
            if (map[key] !== web_utility_1.DiffStatus.Same)
                return _this.createNode(vNode, deletingGroup);
            var oldVNode = _this.vNodeOf(oldList, key);
            return vNode.text != null
                ? (vNode.node = oldVNode.node)
                : _this.patch(oldVNode, vNode).node;
        });
        for (var selector in deletingGroup)
            try {
                for (var _d = (e_4 = void 0, tslib_1.__values(deletingGroup[selector])), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var vNode = _e.value;
                    this.deleteNode(vNode);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_4) throw e_4.error; }
            }
        this.commitChildren(node, newNodes);
        try {
            for (var newList_1 = tslib_1.__values(newList), newList_1_1 = newList_1.next(); !newList_1_1.done; newList_1_1 = newList_1.next()) {
                var _f = newList_1_1.value, ref = _f.ref, node_1 = _f.node;
                ref === null || ref === void 0 ? void 0 : ref(node_1);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (newList_1_1 && !newList_1_1.done && (_b = newList_1.return)) _b.call(newList_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    DOMRenderer.prototype.handleCustomEvent = function (node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function (value) {
                if (handler)
                    node.removeEventListener(event, handler);
                node.addEventListener(event, (handler = value));
            },
            get: function () { return handler; }
        });
    };
    DOMRenderer.prototype.patch = function (oldVNode, newVNode) {
        var _a;
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, this.removeProperty, this.setProperty);
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function (node, key) { return node.removeProperty((0, web_utility_1.toHyphenCase)(key)); }, function (node, key, value) { return node.setProperty((0, web_utility_1.toHyphenCase)(key), value); });
        this.updateChildren(oldVNode.node, oldVNode.children || [], (newVNode.children = ((_a = newVNode.children) === null || _a === void 0 ? void 0 : _a.map(function (vNode) { return new VDOM_1.VNode(vNode); })) || []));
        newVNode.node = oldVNode.node;
        return newVNode;
    };
    DOMRenderer.prototype.render = function (vNode, node) {
        var _a;
        if (node === void 0) { node = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.body; }
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || VDOM_1.VNode.fromDOM(node);
        root = this.patch(root, new VDOM_1.VNode(tslib_1.__assign(tslib_1.__assign({}, root), { children: [vNode] })));
        this.treeCache.set(node, root);
        return root;
    };
    DOMRenderer.prototype.buildRenderTree = function (tree) {
        var body = this.document.implementation.createHTMLDocument().body;
        this.render(tree, body);
        var shadowRoots = tslib_1.__spreadArray([], tslib_1.__read((0, declarative_shadow_dom_polyfill_1.findShadowRoots)(body)), false);
        return { body: body, shadowRoots: shadowRoots };
    };
    DOMRenderer.prototype.renderToStaticMarkup = function (tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return body.getHTML({ serializableShadowRoots: true, shadowRoots: shadowRoots });
    };
    DOMRenderer.prototype.renderToReadableStream = function (tree) {
        var _a = this.buildRenderTree(tree), body = _a.body, shadowRoots = _a.shadowRoots;
        return web_streams_polyfill_1.ReadableStream.from((0, declarative_shadow_dom_polyfill_1.generateHTML)(body, { serializableShadowRoots: true, shadowRoots: shadowRoots }));
    };
    return DOMRenderer;
}());
exports.DOMRenderer = DOMRenderer;
